import { Map } from 'leaflet';
import { rotationControlEvents } from '../events/rotationControlEvents';
import 'leaflet-rotate';

export const rotationControlFunction = (map: any, mapRef: React.Ref<Map>, dispatch: any) => {
    /*event functions for rotation control */
    rotationControlEvents(map, dispatch);

    //@ts-ignore
    if (mapRef && mapRef.current) {
        const rotationControls = document.getElementsByClassName('leaflet-control-rotate');
        const elementsToRemove = Array.from(rotationControls).slice(0, 1);
        /*remove the default rotate control button to fix multiple button bug */
        elementsToRemove.forEach((element) => {
            element.remove();
        });
        //@ts-ignore
        const rotateControl = L.control.rotate({ position: 'topleft', closeOnZeroBearing: false });
        //@ts-ignore
        rotateControl.addTo(mapRef.current);
        //mapRef.current.setBearing(1)
    }
    return () => {
        //@ts-ignore
        if (mapRef && mapRef.current && mapRef.current.control) {
            //@ts-ignore
            mapRef.current.removeControl(L.control.rotate({ position: 'topleft', closeOnZeroBearing: false })); // Remove the rotation control on component unmount
        }
    };
};
